export const BUTTON_VARIANT = {
  CTA: 'cta',
  MUTED: 'muted',
  OUTLINED: 'outlined',
} as const;

export const SPINNER_STROKE = {
  DEFAULT: 'white',
  TEAL: 'var(--cureskin-teal-600)',
} as const;
